import React from 'react';
import { useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Button, Stack, TextField } from '@mui/material';
import useAuth from '../../hooks/useAuth';

const ConfirmVerified: React.FC = () => {
  const { confirmVerified } = useAuth();
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token');
  const RegExp = /^\d+\.?\d*$/;
  return (
    <Formik
      initialValues={{
        code: ''
      }}
      validationSchema={Yup.object().shape({
        code: Yup.string().required('Code is required').matches(RegExp, 'Is not valid')
      })}
      onSubmit={(values) => {
        confirmVerified(values.code, token);
      }}
    >
      {({ errors, handleSubmit, touched, getFieldProps }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Stack direction="column" spacing={3} justifyContent="center">
            <TextField
              fullWidth
              label="Code"
              {...getFieldProps('code')}
              error={Boolean(touched.code && errors.code)}
              helperText={touched.code && errors.code}
            />
            <Button type="submit" fullWidth variant="contained" color="primary">
              Verify
            </Button>
          </Stack>
        </form>
      )}
    </Formik>
  );
};

export default ConfirmVerified;
